<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card
          style="border-color: green"
          outlined
        >
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-center text-h5 mb-1">
                Storage Invoiced Previous 30 Days
              </v-list-item-title>
              <v-progress-linear
                v-if="loadingMetrics"
                class="text-center"
                color="green"
                indeterminate
              />
              <v-list-item-title
                v-else
                class="text-center text-h5 mb-1"
              >
                {{ metrics.totalStorageInvoicedPreviousThirtyDays | currency }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col>
        <v-card
          style="border-color: green"
          outlined
        >
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-center text-h5 mb-1">
                Storage Invoiced Previous 90 Days
              </v-list-item-title>
              <v-progress-linear
                v-if="loadingMetrics"
                class="text-center"
                color="green"
                indeterminate
              />
              <v-list-item-title
                v-else
                class="text-center text-h5 mb-1"
              >
                {{ metrics.totalStorageInvoicedPreviousNinetyDays | currency }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col>
        <v-card
          style="border-color: green"
          outlined
        >
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-center text-h5 mb-1">
                Storage Invoiced YTD
              </v-list-item-title>
              <v-progress-linear
                v-if="loadingMetrics"
                class="text-center"
                color="green"
                indeterminate
              />
              <v-list-item-title
                v-else
                class="text-center text-h5 mb-1"
              >
                {{ metrics.totalStorageInvoicedPreviousYear | currency }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card
          style="border-color: green"
          outlined
        >
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-center text-h5 mb-1">
                Warehouse Services Previous 30 Days
              </v-list-item-title>
              <v-progress-linear
                v-if="loadingMetrics"
                class="text-center"
                color="green"
                indeterminate
              />
              <v-list-item-title
                v-else
                class="text-center text-h5 mb-1"
              >
                {{ metrics.totalWarehouseServicesPreviousThirtyDays | currency }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col>
        <v-card
          style="border-color: green"
          outlined
        >
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-center text-h5 mb-1">
                Warehouse Services Previous 90 Days
              </v-list-item-title>
              <v-progress-linear
                v-if="loadingMetrics"
                class="text-center"
                color="green"
                indeterminate
              />
              <v-list-item-title
                v-else
                class="text-center text-h5 mb-1"
              >
                {{ metrics.totalWarehouseServicesThreeMonthsAgo | currency }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col>
        <v-card
          style="border-color: green"
          outlined
        >
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-center text-h5 mb-1">
                Warehouse Services YTD
              </v-list-item-title>
              <v-progress-linear
                v-if="loadingMetrics"
                class="text-center"
                color="green"
                indeterminate
              />
              <v-list-item-title
                v-else
                class="text-center text-h5 mb-1"
              >
                {{ metrics.totalWarehouseServicesYearToDate | currency }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card
          style="border-color: green"
          outlined
        >
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-center text-h5 mb-1">
                Materials Previous 30 Days
              </v-list-item-title>
              <v-progress-linear
                v-if="loadingMetrics"
                class="text-center"
                color="green"
                indeterminate
              />
              <v-list-item-title
                v-else
                class="text-center text-h5 mb-1"
              >
                {{ metrics.totalMaterialInvoicedPreviousThirtyDays | currency }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col>
        <v-card
          style="border-color: green"
          outlined
        >
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-center text-h5 mb-1">
                Materials Previous 90 Days
              </v-list-item-title>
              <v-progress-linear
                v-if="loadingMetrics"
                class="text-center"
                color="green"
                indeterminate
              />
              <v-list-item-title
                v-else
                class="text-center text-h5 mb-1"
              >
                {{ metrics.totalMaterialsInvoicedThreeMonthsAgo | currency }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col>
        <v-card
          style="border-color: green"
          outlined
        >
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-center text-h5 mb-1">
                Materials YTD
              </v-list-item-title>
              <v-progress-linear
                v-if="loadingMetrics"
                class="text-center"
                color="green"
                indeterminate
              />
              <v-list-item-title
                v-else
                class="text-center text-h5 mb-1"
              >
                {{ metrics.totalMaterialsInvoicedYearToDate | currency }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <!-- <div> -->
    <v-row>
      <v-col>
        <canvas id="chart" />
      </v-col>
      <v-col>
        <canvas id="deltas" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <canvas id="dailyChargeSum" />
      </v-col>
      <v-col>
        <canvas id="dailyChargeDeltas" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <canvas id="cumulativeCharges" />
      </v-col>
      <v-col>
        <canvas id="cumulativeChargesDeltas" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Chart } from 'chart.js';
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'MetricsComponent',
  data: () => ({
    metrics: {},
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    cubicFootage: 0,
    loadingMetrics: false,
  }),
  computed: {
    formatCurrency(val) {
      return this.$currency(val);
    },
  },
  created() {
    this.metrics = this.getMetrics();
    this.getPieceCountMetrics(this.startDate, this.endDate);
    this.getCubicFootage();
    this.getDailyChargeMetrics();
  },
  methods: {
    ...mapActions('apiClient', ['get']),
    async getCubicFootage() {
      await this.get({ url: '/inventory/metrics/cubicFootage' }).then(
        (response) => {
          this.cubicFootage = response.data.value;
        },
      );
    },
    async getDailyChargeMetrics() {
      await this.get({ url: '/inventory/metrics/daily' }).then(
        (response) => {
          console.log(response);
          const dailyLabels = [];
          const dailyValues = [];
          const dailyDeltas = [];
          const cumulativeLabels = [];
          const cumulativeValues = [];
          const cumulativeDeltas = [];

          const dailyData = response.data.daily;
          const cumulativeData = response.data.cumulative;

          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < dailyData.length; i++) {
            dailyLabels.push(dailyData[i].label);
            dailyValues.push(dailyData[i].value);

            if (i > 0) {
              const delta = dailyData[i].value - dailyData[i - 1].value;
              dailyDeltas.push(delta);
            } else {
              dailyDeltas.push(0);
            }
          }
          const chargeSumCtx = document.getElementById('dailyChargeSum');

          // eslint-disable-next-line no-unused-vars
          const chargeSumChart = new Chart(chargeSumCtx, {
            type: 'line',
            data: {
              labels: dailyLabels,
              datasets: [{
                label: 'Storage Accrued Per Day',
                data: dailyValues,
                fill: true,
                borderColor: 'rgb(21, 101, 192)',
                tension: 0.5,
              }],
            },
            options: {
              scales: {
                y: {
                  ticks: {
                    // eslint-disable-next-line no-unused-vars
                    callback(value, index, ticks) {
                      // eslint-disable-next-line prefer-template
                      return '$' + value;
                    },
                  },
                },
              },
            },

          });

          // eslint-disable-next-line no-unused-vars
          const dailyChargeDeltas = new Chart(document.getElementById('dailyChargeDeltas'), {
            type: 'line',
            data: {
              labels: dailyLabels,
              datasets: [{
                label: 'Net Change From Previous Day',
                data: dailyDeltas,
                fill: true,
                borderColor: 'rgb(21, 101, 192)',
                tension: 0.5,
              }],
            },
            options: {
              scales: {
                y: {
                  ticks: {
                    // eslint-disable-next-line no-unused-vars
                    callback(value, index, ticks) {
                      // eslint-disable-next-line prefer-template
                      return '$' + value;
                    },
                  },
                },
              },
            },
          });

          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < cumulativeData.length; i++) {
            cumulativeLabels.push(cumulativeData[i].label);
            cumulativeValues.push(cumulativeData[i].value);

            if (i > 0) {
              const delta = cumulativeData[i].value - cumulativeData[i - 1].value;
              cumulativeDeltas.push(delta);
            } else {
              cumulativeDeltas.push(0);
            }
          }

          // eslint-disable-next-line no-unused-vars
          const cumulativeChart = new Chart(document.getElementById('cumulativeCharges'), {
            type: 'line',
            data: {
              labels: cumulativeLabels,
              datasets: [{
                label: 'Cumulative Charges',
                data: cumulativeValues,
                fill: true,
                borderColor: 'rgb(21, 101, 192)',
                tension: 0.5,
              }],
            },
            options: {
              scales: {
                y: {
                  ticks: {
                    // eslint-disable-next-line no-unused-vars
                    callback(value, index, ticks) {
                      // eslint-disable-next-line prefer-template
                      return '$' + value;
                    },
                  },
                },
              },
            },
          });

          // eslint-disable-next-line no-unused-vars
          const cumulativeDeltaChart = new Chart(document.getElementById('cumulativeChargesDeltas'), {
            type: 'line',
            data: {
              labels: cumulativeLabels,
              datasets: [{
                label: 'Net Change from Previous Day',
                data: cumulativeDeltas,
                fill: true,
                borderColor: 'rgb(21, 101, 192)',
                tension: 0.5,
              }],
            },
            options: {
              scales: {
                y: {
                  ticks: {
                    // eslint-disable-next-line no-unused-vars
                    callback(value, index, ticks) {
                      // eslint-disable-next-line prefer-template
                      return '$' + value;
                    },
                  },
                },
              },
            },
          });
        },
        (error) => {
          console.log(error);
        },
      );
    },
    async getPieceCountMetrics(startDate, endDate) {
      await this.get({ url: `/inventory/metrics/counts?startDate=${startDate}&endDate=${endDate}` }).then(
        (response) => {
          const counts = response.data;
          const ctx = document.getElementById('chart');
          const labels = [];
          const values = [];
          const deltas = [];
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < counts.length; i++) {
            labels.push(counts[i].label);
            values.push(counts[i].value);

            if (i > 0) {
              const delta = counts[i].value - counts[i - 1].value;
              deltas.push(delta);
            } else {
              deltas.push(0);
            }
          }
          // eslint-disable-next-line no-unused-vars
          const myChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels,
              datasets: [{
                label: 'Piece Counts',
                data: values,
                fill: true,
                borderColor: 'rgb(21, 101, 192)',
                tension: 0.5,
              }],
            },
            options: {},
          });

          const deltaCtx = document.getElementById('deltas');
          // eslint-disable-next-line no-unused-vars
          const deltaChart = new Chart(deltaCtx, {
            type: 'line',
            data: {
              labels,
              datasets: [{
                label: 'Net Change From Previous Day',
                data: deltas,
                fill: true,
                borderColor: 'rgb(21, 101, 192)',
                tension: 0.5,
              }],
            },
          });
        },
      );
    },
    async getMetrics() {
      this.loadingMetrics = true;
      await this.get({ url: '/inventory/metrics' }).then(
        (response) => {
          this.metrics = response.data;
        },
        (error) => {
          console.log(error);
        },
      ).finally(() => { this.loadingMetrics = false; });
    },
  },
};
</script>
